import React, { ComponentProps, FunctionComponent } from "react";

const DiningIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 86",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M89.6099 26.0008C96.0005 19.6101 97.1099 9.89142 91.5525 4.33409C85.9952 -1.22325 76.5525 -0.10858 69.8859 6.27675C65.1619 11.0008 63.2192 17.6674 64.8859 22.9434L44.8859 42.9434L40.9952 39.0528L3.22452 1.27675C-7.05148 8.77675 13.5005 40.1674 24.6152 56.0008L33.5059 47.1101L37.3965 51.0008L10.7299 77.6674L18.5059 85.4434L45.1725 58.7768L71.8392 85.4434L79.6152 77.6674L52.9432 51.0008L72.9432 31.0008C78.2244 32.6674 84.8911 31.0008 89.6099 26.0008Z",
    })
  );
};

const ForwardRef = React.forwardRef(DiningIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
